import React from 'react';
import clsx from 'clsx';
export function XLoader(_a) {
    var size = _a.size, className = _a.className;
    size = size !== null && size !== void 0 ? size : 0;
    return React.createElement("div", { className: clsx(className, "XLoader size-" + size) });
}
